/**
 * The `SortableOnNavigateEvent` event.
 */
var SortableOnNavigateEvent = /** @class */ (function () {
    /**
     * @hidden
     */
    function SortableOnNavigateEvent(target, prevIndex, nextIndex, newState) {
        this.target = target;
        this.prevIndex = prevIndex;
        this.nextIndex = nextIndex;
        this.newState = newState;
    }
    return SortableOnNavigateEvent;
}());
export { SortableOnNavigateEvent };
//# sourceMappingURL=SortableOnNavigateEvent.js.map